import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { DistrictMiniEntity } from '../../domain/entities/DistrictMiniEntity'
import type { DistrictsByRegionDistrictAdminDto } from '@/backend/market'
 
export class DistrictMiniModel extends DistrictMiniEntity {
  constructor(dataDto: DistrictsByRegionDistrictAdminDto) {
    super()
    mapEntityProperties<DistrictMiniModel>(this, dataDto)
  }
}
